module.exports = __webpack_public_path__ + "img/3_196.28ba5b3c.png";